const fiilMadhi = {
  feelEnds: [
    'َ',
    'َا',
    'ُوا',
    'َتْ',
    'َتَا',
    'ْنَ',
    'ْتَ',
    'ْتُمَا',
    'ْتُمْ',
    'ْتِ',
    'ْتُمَا',
    'ْتُنَّ',
    'ْتُ',
    'ْنَا',
  ],
  words: [
    {
      title: { en: '3 Letters', ms: '3 Huruf' },
      verbs: [
        { ar: 'ذَهَب', en: 'Went', ms: 'Pergi' },
        { ar: 'جَلَس', en: 'Sat', ms: 'Duduk' },
      ],
    },
    {
      title: { en: '4 Letters', ms: '4 Huruf' },
      verbs: [
        { ar: 'سَاعَد', en: 'Helped', ms: 'Menolong' },
        { ar: 'عَلَّم', en: 'Taught', ms: 'Mengajar' },
      ],
    },
    {
      title: { en: '5 Letters', ms: '5 Huruf' },
      verbs: [
        { ar: 'تَقَابَل', en: 'Met', ms: 'Berjumpa' },
        { ar: 'تَنَاوَل', en: 'Took', ms: 'Mengambil' },
      ],
    },
    {
      title: { en: '6 Letters', ms: '6 Huruf' },
      verbs: [
        { ar: 'اِسْتَخْرَج', en: 'Extracted', ms: 'Mengeluarkan' },
        { ar: 'اِسْتَقْبَل', en: 'Celebrated', ms: 'Menyambut' },
      ],
    },
  ],
};

export default fiilMadhi;
